// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"z8-z"};